<template>
  <div>
    <v-container>
      <v-row v-if="previewSimulador">
        <v-col cols="12" align-self="center">
          <v-btn class="btn_style3" dark @click="$emit('closeL')">VOLVER</v-btn>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-alert color="primary" dark class="">
            <div style="text-align: center">
              <h1>{{ tituloBalotario }}</h1>
            </div>
          </v-alert>
        </v-col>

        <v-col cols="12">
          <template>
            <v-card class="bg">
              <v-window v-model="step">
                <v-window-item v-for="(respta, i) in arrayPreguntasYrespuestas" :value="i + 1" :key="i">
                  <v-card-text>
                    <v-row>
                      <v-col cols="8" offset="2" class="pb-0">
                        <div class="pb-0 text-center">
                          <p class="pt-2 mb-0" v-html="respta.pregunta"></p>

                          <!-- <h2 class="text-center">
    
                                {{ respta.pregunta }}
    
                              </h2> -->
                        </div>
                      </v-col>

                      <v-col cols="8" offset="2" class="py-0">
                        <v-radio-group v-model="radioGroup">
                          <!-- :color="resptar.valor_respuesta == 'true'?'green':'blue'" -->

                          <v-alert v-for="(resptar, n) of respta.respuestas" :key="n" v-model="alertRespuestas" :color="resptar.valor_respuesta ? 'green' : '#0000000'
                            " elevation="5" dense border="left">
                            <v-row align="center">
                              <v-col class="grow">
                                <v-radio :dark="resptar.valor_respuesta ? true : false"
                                  :value="resptar.valor_respuesta ? 1 : 0">

                                  <template v-slot:label>
                                    <div style="padding:10px" v-html="resptar.valor_respuesta
                                      ? resptar.respuesta +
                                      ' ( Respuesta Correcta )'
                                      : resptar.respuesta"></div>
                                  </template>
                                </v-radio>
                              </v-col>

                              <v-col v-if="resptar.valor_respuesta" class="shrink">
                                <v-icon>fas fa-check</v-icon>
                              </v-col>
                            </v-row>
                          </v-alert>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-window-item>
              </v-window>

              <v-card-actions>
                <v-row>
                  <v-col cols="2" class="text-center">
                    <v-btn :disabled="step === 1" color="success" depressed @click="prevpageSimulador">
                      Anterior
                    </v-btn>
                  </v-col>

                  <v-col cols="8" class="text-center align-self-center">
                    <v-progress-linear disabled v-model="cantPreguntas" height="20" rounded>
                      <strong>{{ Math.ceil(cantPreguntas) }}%</strong>
                    </v-progress-linear>
                  </v-col>

                  <v-col cols="2" class="text-center">
                    <v-btn :disabled="step === contadorPreguntas" color="primary" depressed @click="nextpageSimulador">
                      Siguiente
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>

            <br /><br />
          </template>
        </v-col>
      </v-row>
    </v-container>

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal()">
    </component>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
export default {
  name: "previewSimulador",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {},
  data: () => ({
    tituloBalotario: "Tema",
    arrayPreguntasYrespuestas: [],
    search: null,
    cantPreguntas: 0,
    contadorPreguntas: null,
    step: 1,
    radioGroup: 1,
    titleCreation: "Filtrar preguntas", //POR USAR AUN
    nombre_unidad: "",
    alertRespuestas: "",
    previewSimulador: true,
    compName: null,
    estadoComponente: null,
    parametroComp: null,
  }),
  methods: {

    async listarPreguntaRespuestasDetalleClase() {
      const me = this;
      try {
        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorRespuestas/simuladorR/listares/" +
          me.parametros.items.item.id
        );

        if (response.data.length == 0) {
          me.snackbarOrden = true;
          me.colorsnackbarOrden = "red";
          me.textAlertOrden = "NO TIENES BALOTARIO PARA ESTA CLASE";
        } else {
          me.titleCreation = "Simulador de examenes";
          me.tituloBalotario = "Tema: " + me.parametros.items.item.unidad;
          console.log(me.parametros);

          let map = new Map();
          response.data.forEach((currentValue) => {
            map.has(currentValue.pregunta)
              ? map.get(currentValue.pregunta).push({
                estado: currentValue.estado,
                idpregunta: currentValue.idpregunta,
                idrespuesta: currentValue.idrespuesta,
                idtema: currentValue.idtema,
                orden: currentValue.orden,
                respuesta: currentValue.respuesta,
                valor_respuesta: currentValue.valor_respuesta,
              })
              : map.set(currentValue.pregunta, [
                {
                  estado: currentValue.estado,
                  idpregunta: currentValue.idpregunta,
                  idrespuesta: currentValue.idrespuesta,
                  idtema: currentValue.idtema,
                  orden: currentValue.orden,
                  respuesta: currentValue.respuesta,
                  valor_respuesta: currentValue.valor_respuesta,
                },
              ]);
          });

          const arr = Array.from(map, ([pregunta, respuestas]) => {
            // return { [key]: value };
            return { pregunta, respuestas };
          });

          me.arrayPreguntasYrespuestas = arr;
          let contadorPag = arr.length;
          me.contadorPreguntas = contadorPag;
          me.totalPag = 100 / contadorPag;
          // me.cantPreguntas = me.totalPag;
        }
      } catch (error) {
        console.log(error);
      }
    },
    prevpageSimulador() {
      const me = this;
      me.step--;

      if (me.step == 1) {
        me.cantPreguntas = me.totalPag * 0;
      } else {
        me.cantPreguntas = me.totalPag * me.step;
      }
      console.log(me.cantPreguntas);
      console.log(me.step);
    },
    nextpageSimulador() {
      const me = this;
      me.step++;
      me.cantPreguntas = me.totalPag * me.step;

      console.log(me.cantPreguntas);
      console.log(me.step);
    },
    closeModal() {
      this.estadoComponente = false;
      this.previewSimulador = true;
    },
  },
  mounted() {
    this.listarPreguntaRespuestasDetalleClase();
  },
  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.previewSimulador = true;
        this.listarPreguntaRespuestasDetalleClase();
      } else {
        this.previewSimulador = false;
      }
    },
  },
};
</script>

<style></style>
